var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"law-empty",style:({height: _vm.lHeight || 'calc(100vh - 170px)'})},[_c('mars-view',[_c('mars-view',{staticClass:"icon iconfont empty-icon",style:({fontSize: _vm.fontSize})},[_vm._t("default")],2),_c('mars-view',{staticClass:"law-empty-text",style:(_vm.txtStyle)},[_vm._v(" "+_vm._s(_vm.txt))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }